import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button, Card, Divider, Modal, Select, Space, Tabs, Pagination } from "antd";
import Layouts from "../../../components/Layouts";
import { getDirectusClient } from "../../../lib/directus";
import Addfileproducts from "../components/Addfileproducts";
import Addcaja from "../components/Addcaja";
import { readItem, readItems, updateItem, updateItems } from "@directus/sdk";
import { useSelector } from "react-redux";
import {
  CreateInventarioNoSerial,
  EditInventarioNoSerial,
  DeleteInventarioNoSerialByOrder,
} from "../../../services/inventarioNoSerial";

import {
  getserialesCount,
  DeleteSerialesByOrder,
  GetSerialesByOrder,
} from "../../../services/seriales";
import { formatPrice } from "../../../lib/utils";

const onChange = (key) => {
  console.log(key);
};

function OrdeEnter() {
  const signoMoneda = useSelector((state) => state.signoMoneda.signo_moneda);
  let { order_id } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNoSerialModalOpen, setIsNoSerialModalOpen] = useState(false);
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(true);
  // Eliminar ingresados/setIngresados global, lo manejaremos por producto seleccionado
  const [productselect, setProductselect] = useState(null);
  const [ingresadosModal, setIngresadosModal] = useState(0); // Solo para el producto seleccionado

  // Pagination state for products
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20); // Default page size
  const [totalProductos, setTotalProductos] = useState(0);

  // Pagination state for seriales modal
  const [serialesModal, setSerialesModal] = useState({
    visible: false,
    producto: null,
    seriales: [],
    total: 0,
    currentPage: 1,
    pageSize: 100,
    loading: false,
  });

  const user = useSelector((state) => state.userdata);
  const navigate = useNavigate();

  const [totals, setTotals] = useState({
    subtotal: 0,
    groupTaxTotal: 0,
    iscTotal: 0,
    grandTotal: 0,
  });
  const [additionalTaxes, setAdditionalTaxes] = useState([]);
  const [productStats, setProductStats] = useState({});
  const [allProductsProcessed, setAllProductsProcessed] = useState(false);

  console.log("orden id", order_id);

  // Helper to fetch paginated products for the order
  const getOrder = async (page = 1, limit = pageSize) => {
    setLoading(true);
    const directus = await getDirectusClient();
    await directus
      .request(
        readItem("ordenes_decompra", order_id, {
          fields: [
            "id",
            "numero_factura",
            "proveedor.nombre",
            "date_created",
            "bodegas.bodegas_id",
            {
              productos: [
                "id",
                "nombre",
                "preciosinimp",
                "grupo.nombre",
                "estado.nombre",
                "seriales",
                { producto_detalle: [
                  "*",
                  { grupo: [
                    "*",
                    { impuestos: [
                      { impuestos_id: ["porcentaje", "nombre", "id"] }
                    ]}
                  ]}
                ]},
                "producto_detalle.id",
                "precio_uni_final",
                "precio_compra",
                "cantidad"
              ]
            },
            "user_created.first_name",
            "user_created.last_name",
          ],
          // Paginate productos
          deep: {
            productos: {
              _limit: limit,
              _page: page,
              _sort: "id",
            },
          },
        })
      )
      .then((res) => {
        let ordenn = res;
        let productos = ordenn.productos || [];
        let total = productos.length;
        // Try to get total count from meta if available (Directus v10+)
        if (ordenn?.productos_meta?.filter_count) {
          total = ordenn.productos_meta.filter_count;
        } else if (ordenn?.productos_meta?.total_count) {
          total = ordenn.productos_meta.total_count;
        } else if (ordenn?.productos?.length && ordenn?.productos?.[0]?._meta?.total_count) {
          total = ordenn.productos[0]._meta.total_count;
        } else if (ordenn?.productos?.length && ordenn?.productos?.[0]?._meta?.filter_count) {
          total = ordenn.productos[0]._meta.filter_count;
        } else if (ordenn?.productos_count) {
          total = ordenn.productos_count;
        }
        setOrder({ ...ordenn, productos });
        setTotalProductos(total);
        setLoading(false);
      });
  };

  // Fetch order and products on mount and when page/pageSize changes
  useEffect(() => {
    getOrder(currentPage, pageSize);
    // eslint-disable-next-line
  }, [currentPage, pageSize]);

  // Nueva función para obtener ingresados SOLO del producto seleccionado
  const fetchIngresadosForProduct = async (producto) => {
    if (!producto) {
      setIngresadosModal(0);
      return;
    }
    const isNonSerialized =
      producto?.producto_detalle?.grupo?.codebar === false &&
      producto?.producto_detalle?.grupo?.iccid === false;

    let totalIngresados;
    if (isNonSerialized) {
      totalIngresados = Number(producto.ingresado_no_serial) || 0;
    } else {
      const response = await getserialesCount(producto.id);
      totalIngresados = Number(response[0]?.countDistinct?.id) || 0;
    }
    setIngresadosModal(totalIngresados);
  };

  const showModal = async (producto) => {
    setProductselect(producto);
    await fetchIngresadosForProduct(producto);

    if (
      producto?.producto_detalle?.grupo?.codebar === false &&
      producto?.producto_detalle?.grupo?.iccid === false
    ) {
      setIsNoSerialModalOpen(true);
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
      setIsNoSerialModalOpen(false);
    }
  };

  const handleOk = async () => {
    setIsModalOpen(false);
    setIsNoSerialModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsNoSerialModalOpen(false);
  };

  console.log(order);

  const handlePartialSuccess = async () => {
    await getOrder(currentPage, pageSize);
    // Cuando se actualiza la orden, también refrescamos los ingresados del producto seleccionado
    if (productselect) {
      await fetchIngresadosForProduct(productselect);
    }
    const directus = await getDirectusClient();
    await directus.request(
      updateItem("ordenes_decompra", order_id, { estado: 2 })
    );
  };

  const items = [
    {
      key: "1",
      label: `Subir Archivo CSV`,
      children: (
        <Addfileproducts
          ingresados={ingresadosModal}
          modal={isModalOpen}
          producto={productselect}
          order={order_id}
          onSuccess={handlePartialSuccess}
          bodegaId={
            order && Object.keys(order).length > 0
              ? order?.bodegas[0]?.bodegas_id
              : null
          }
        />
      ),
    },
    {
      key: "3",
      label: `Por Caja`,
      children: (
        <Addcaja
          ingresados={ingresadosModal}
          producto={productselect}
          order={order_id}
          bodegaId={
            order && Object.keys(order).length > 0
              ? order?.bodegas[0]?.bodegas_id
              : null
          }
          onSuccess={handlePartialSuccess}
        />
      ),
    },
  ];

  const cerrarOrden = async () => {
    Modal.confirm({
      title: "¿Estás seguro de cerrar esta orden?",
      content: "Esta acción no se puede deshacer.",
      okText: "Sí, cerrar orden",
      cancelText: "Cancelar",
      onOk: async () => {
        const directus = await getDirectusClient();
        try {
          // First update order status
          await directus.request(
            updateItem("ordenes_decompra", order_id, {
              estado: 3,
              ingresado_por: user?.id,
            })
          );

          // Check if all products in the order are non-serialized
          const allNonSerialized = order.productos.every(
            (producto) =>
              producto?.producto_detalle?.grupo?.codebar === false &&
              producto?.producto_detalle?.grupo?.iccid === false
          );

          if (allNonSerialized) {
            // If all are non-serialized, skip serial validation and update
            Modal.success({
              content: `Orden de compra no serializada cerrada con éxito.`,
              onOk: () => navigate("/order_list"),
            });
          } else {
            // If there are serialized products, proceed with serial validation and update

            // Get serials with estado 5 and specific order
            const seriales = await directus.request(
              readItems("seriales", {
                filter: {
                  estado: {
                    _eq: 5,
                  },
                  orden_compra_ingreso: {
                    _eq: order_id,
                  },
                },
                limit: -1,
              })
            );

            if (seriales && seriales.length > 0) {
              const updatedSerials = await directus.request(
                updateItems(
                  "seriales",
                  seriales.map((serial) => serial.id),
                  {
                    estado: 1,
                  }
                )
              );

              Modal.success({
                content: `Orden cerrada con éxito. Se activaron ${updatedSerials.length} seriales`,
                onOk: () => navigate("/order_list"),
              });
            }
          }
        } catch (err) {
          console.error("Error:", err);
          Modal.error({
            content: "Error al cerrar la orden",
          });
        }
      },
    });
  };

  const handleProcessNoSerial = async () => {
    const directus = await getDirectusClient();
    try {
      const producto = productselect;
      if (!producto || !producto.id) {
        console.error("No product selected or product ID missing.");
        return;
      }

      const existingInventario = await directus.request(
        readItems("inventario_no_serial", {
          filter: {
            producto: {
              _eq: producto.producto_detalle.id,
            },
          },
          limit: 1,
        })
      );

      let inventarioId;
      const cantidadToAdd = Number(producto.cantidad); // Convert to number

      if (existingInventario && existingInventario.length > 0) {
        const itemToUpdate = existingInventario[0];
        const newCantidad = Number(itemToUpdate.cantidad) + cantidadToAdd; // Convert and add
        await EditInventarioNoSerial(itemToUpdate.id, {
          cantidad: newCantidad,
        });
        inventarioId = itemToUpdate.id;
        console.log(
          `Updated inventario_no_serial for product ${producto.producto_detalle.id}. New quantity: ${newCantidad}`
        );
      } else {
        const newItem = await CreateInventarioNoSerial({
          cantidad: cantidadToAdd,
          nombre: producto.producto_detalle.nombre,
          producto: producto.producto_detalle.id,
        });
        inventarioId = newItem.id;
        console.log(
          `Created new inventario_no_serial for product ${producto.producto_detalle.id}. Quantity: ${cantidadToAdd}`
        );
      }

      // Manually update the order state to reflect the processed quantity for non-serialized items
      setOrder((prevOrder) => {
        const newProductos = prevOrder.productos.map((p) => {
          if (p.id === producto.id) {
            const isNonSerialized =
              p?.producto_detalle?.grupo?.codebar === false &&
              p?.producto_detalle?.grupo?.iccid === false;
            if (isNonSerialized) {
              return {
                ...p,
                ingresado_no_serial:
                  (p.ingresado_no_serial || 0) + cantidadToAdd,
              };
            }
          }
          return p; // Return unchanged product for serialized items or other products
        });
        return { ...prevOrder, productos: newProductos };
      });

      // Refrescar ingresados para el producto seleccionado
      await fetchIngresadosForProduct(producto);

      Modal.success({
        content: `Procesados ${cantidadToAdd} unidades de ${producto.producto_detalle.nombre}`,
        onOk: async () => {
          handleCancel(); // Close the modal
        },
      });
    } catch (error) {
      console.error("Error processing non-serial item:", error);
      Modal.error({
        content: `Error al procesar el producto: ${error.message}`,
      });
    }
  };

  const handleDeleteAddedProducts = async (producto) => {
    const isNonSerialized =
      producto?.producto_detalle?.grupo?.codebar === false &&
      producto?.producto_detalle?.grupo?.iccid === false;

    Modal.confirm({
      title: "¿Estás seguro de eliminar todos los productos agregados?",
      content: `Esta acción eliminará todos los ${
        isNonSerialized ? "productos no serializados" : "seriales"
      } agregados para ${
        producto.producto_detalle?.nombre
      }. Esta acción no se puede deshacer.`,
      okText: "Sí, eliminar",
      cancelText: "Cancelar",
      onOk: async () => {
        try {
          if (isNonSerialized) {
            const result = await DeleteInventarioNoSerialByOrder(
              order_id,
              producto.producto_detalle.id
            );

            if (result.success) {
              setOrder((prevOrder) => {
                const newProductos = prevOrder.productos.map((p) => {
                  if (p.id === producto.id) {
                    return {
                      ...p,
                      ingresado_no_serial: 0,
                    };
                  }
                  return p;
                });
                return { ...prevOrder, productos: newProductos };
              });

              // Refrescar ingresados para el producto seleccionado si corresponde
              if (productselect && productselect.id === producto.id) {
                setIngresadosModal(0);
              }

              Modal.success({
                content: `Se eliminaron todos los productos no serializados de ${producto.producto_detalle?.nombre}`,
              });
            } else {
              Modal.error({
                content:
                  result.message ||
                  "Error al eliminar productos no serializados",
              });
            }
          } else {
            const result = await DeleteSerialesByOrder(order_id, producto.id);

            if (result.success) {
              // Refrescar ingresados para el producto seleccionado si corresponde
              if (productselect && productselect.id === producto.id) {
                await fetchIngresadosForProduct(producto);
              }
              Modal.success({
                content: `Se eliminaron ${result.serialesEliminados} seriales de ${producto.producto_detalle?.nombre}`,
              });
            } else {
              Modal.error({
                content: result.message || "Error al eliminar seriales",
              });
            }
          }

          // Recargar la orden para actualizar las estadísticas
          await getOrder(currentPage, pageSize);
        } catch (error) {
          console.error("Error eliminando productos:", error);
          Modal.error({
            content: "Error al eliminar los productos agregados",
          });
        }
      },
    });
  };

  // PAGINADO DE SERIALES EN MODAL
  const handleViewAddedProducts = async (producto) => {
    const isNonSerialized =
      producto?.producto_detalle?.grupo?.codebar === false &&
      producto?.producto_detalle?.grupo?.iccid === false;

    if (isNonSerialized) {
      const stats = productStats[producto.id] || { totalIngresados: 0 };
      Modal.info({
        title: `Productos no serializados agregados`,
        content: (
          <div>
            <p>
              <strong>Producto:</strong> {producto.producto_detalle?.nombre}
            </p>
            <p>
              <strong>Cantidad agregada:</strong> {stats.totalIngresados}
            </p>
            <p>
              <strong>Tipo:</strong> Producto no serializado
            </p>
          </div>
        ),
      });
    } else {
      // Abrir modal paginado de seriales
      setSerialesModal({
        visible: true,
        producto,
        seriales: [],
        total: 0,
        currentPage: 1,
        pageSize: 100,
        loading: true,
      });
      fetchSerialesPage(producto, 1, 100);
    }
  };

  // Función para obtener seriales paginados
  const fetchSerialesPage = async (producto, page, pageSize) => {
    setSerialesModal((prev) => ({ ...prev, loading: true }));
    try {
      // Asumimos que GetSerialesByOrder soporta paginado (page, pageSize)
      const result = await GetSerialesByOrder(order_id, producto.id, page, pageSize);
      // Si el servicio no soporta paginado, deberías implementarlo en el backend.
      // Suponemos que retorna { data: [], meta: { total_count } } o un array simple.
      let seriales = [];
      let total = 0;
      if (Array.isArray(result)) {
        seriales = result;
        total = result.length < pageSize && page === 1 ? result.length : undefined;
      } else if (result && result.data) {
        seriales = result.data;
        total = result.meta?.total_count || result.meta?.filter_count || seriales.length;
      }
      // Si no hay total, intentamos obtener todos los seriales para contar
      if (typeof total !== "number") {
        // fallback: obtener todos los seriales para contar
        const allSeriales = await GetSerialesByOrder(order_id, producto.id, 1, -1);
        total = Array.isArray(allSeriales) ? allSeriales.length : 0;
      }
      setSerialesModal((prev) => ({
        ...prev,
        seriales,
        total,
        currentPage: page,
        pageSize,
        loading: false,
      }));
    } catch (error) {
      setSerialesModal((prev) => ({ ...prev, loading: false }));
      Modal.error({
        content: "Error al obtener la lista de seriales",
      });
    }
  };

  const closeSerialesModal = () => {
    setSerialesModal({
      visible: false,
      producto: null,
      seriales: [],
      total: 0,
      currentPage: 1,
      pageSize: 100,
      loading: false,
    });
  };

  const handleSerialesPageChange = (page, pageSize) => {
    if (serialesModal.producto) {
      fetchSerialesPage(serialesModal.producto, page, pageSize);
    }
  };

  // getProductStats ya no debe setear ingresados global, solo retorna los stats
  const getProductStats = async (producto) => {
    // Check if the product is non-serialized
    const isNonSerialized =
      producto?.producto_detalle?.grupo?.codebar === false &&
      producto?.producto_detalle?.grupo?.iccid === false;

    let totalIngresados;
    if (isNonSerialized) {
      totalIngresados = Number(producto.ingresado_no_serial) || 0;
    } else {
      const response = await getserialesCount(producto.id);
      totalIngresados = Number(response[0]?.countDistinct?.id) || 0;
    }

    const cantidadPendiente = Number(producto.cantidad) - totalIngresados;
    const precioTotal = totalIngresados * Number(producto.precio_uni_final);

    return {
      totalIngresados,
      cantidadPendiente,
      precioTotal,
    };
  };

  const [orderTotals, setOrderTotals] = useState({
    totalProductos: 0,
    totalIngresados: 0,
    totalPendientes: 0,
    precioTotal: 0,
  });

  useEffect(() => {
    const calculateOrderTotals = async () => {
      if (!order.productos || order.productos.length === 0) return;

      let totalProductos = 0;
      let totalIngresados = 0;
      let totalPendientes = 0;
      let precioTotal = 0;
      let groupTaxTotal = 0;
      let iscTotal = 0;
      let additionalTaxesMap = new Map(); // To track individual tax names and amounts

      for (const producto of order.productos) {
        const stats = await getProductStats(producto);

        totalProductos += Number(producto.cantidad);
        totalIngresados += Number(stats.totalIngresados);
        totalPendientes += Number(stats.cantidadPendiente);
        precioTotal += Number(stats.precioTotal);

        // Calcular impuestos por producto
        const directus = await getDirectusClient();
        const groupTaxPercentage = parseFloat(
          producto.producto_detalle?.grupo?.impuesto || 0
        );

        // Special calculation for CRC currency (₡)
        if (signoMoneda === "₡") {
          // Para '₡', el ITBMS se calcula sobre el precio de compra unitario.
          const precioCompraUnitario = Number(producto.precio_compra);
          const productBasePrice = Number(stats.precioTotal);
          // La base para el ITBMS es el precio unitario por la cantidad de productos YA INGRESADOS.
          const baseParaItbms =
            precioCompraUnitario * Number(stats.totalIngresados);

          // ITBMS calculation on Precio # for CRC
          const productGroupTax = baseParaItbms * (groupTaxPercentage / 100);
          groupTaxTotal += productGroupTax;

          // Additional taxes calculation on Final V (precioTotal) - using the impuestos from the group
          if (
            producto.producto_detalle?.grupo?.impuestos &&
            producto.producto_detalle.grupo.impuestos.length > 0
          ) {
            producto.producto_detalle.grupo.impuestos.forEach((impuesto) => {
              const impuestoPercentage = parseFloat(
                impuesto.impuestos_id?.porcentaje || 0
              );
              const impuestoNombre =
                impuesto.impuestos_id?.nombre || "Impuesto Adicional";
              if (impuestoPercentage > 0) {
                const productIscAmount =
                  productBasePrice * (impuestoPercentage / 100);
                iscTotal += productIscAmount;

                // Track individual tax amounts
                if (additionalTaxesMap.has(impuestoNombre)) {
                  additionalTaxesMap.set(
                    impuestoNombre,
                    additionalTaxesMap.get(impuestoNombre) + productIscAmount
                  );
                } else {
                  additionalTaxesMap.set(impuestoNombre, productIscAmount);
                }
              }
            });
          }
        } else {
          // Normal calculation for other currencies
          const productBasePrice = Number(stats.precioTotal);

          // Calcular ITBMS
          const productGroupTax = productBasePrice * (groupTaxPercentage / 100);
          groupTaxTotal += productGroupTax;

          // Calcular impuestos adicionales usando los impuestos del grupo
          if (
            producto.producto_detalle?.grupo?.impuestos &&
            producto.producto_detalle.grupo.impuestos.length > 0
          ) {
            producto.producto_detalle.grupo.impuestos.forEach((impuesto) => {
              const impuestoPercentage = parseFloat(
                impuesto.impuestos_id?.porcentaje || 0
              );
              const impuestoNombre =
                impuesto.impuestos_id?.nombre || "Impuesto Adicional";
              if (impuestoPercentage > 0) {
                const productIscAmount =
                  productBasePrice * (impuestoPercentage / 100);
                iscTotal += productIscAmount;

                // Track individual tax amounts
                if (additionalTaxesMap.has(impuestoNombre)) {
                  additionalTaxesMap.set(
                    impuestoNombre,
                    additionalTaxesMap.get(impuestoNombre) + productIscAmount
                  );
                } else {
                  additionalTaxesMap.set(impuestoNombre, productIscAmount);
                }
              }
            });
          }
        }
      }

      // Convert Map to array for state
      const additionalTaxesArray = Array.from(additionalTaxesMap.entries()).map(
        ([name, amount]) => ({
          name,
          amount,
        })
      );

      setOrderTotals({
        totalProductos,
        totalIngresados,
        totalPendientes,
        precioTotal,
      });

      setAdditionalTaxes(additionalTaxesArray);

      setTotals({
        subtotal: precioTotal,
        groupTaxTotal,
        iscTotal,
        grandTotal: precioTotal + groupTaxTotal + iscTotal,
      });
    };

    calculateOrderTotals();
    // eslint-disable-next-line
  }, [order.productos, signoMoneda]);

  useEffect(() => {
    const fetchProductStats = async () => {
      if (!order.productos || order.productos.length === 0) return;

      const stats = {};
      for (const producto of order.productos) {
        stats[producto.id] = await getProductStats(producto);
      }
      setProductStats(stats);
    };

    fetchProductStats();
    // eslint-disable-next-line
  }, [order.productos]);

  useEffect(() => {
    const checkAllProductsProcessed = () => {
      if (!order.productos || order.productos.length === 0) return false;

      // Verificar si todos los productos tienen cantidadPendiente === 0
      const allProcessed = order.productos.every((producto) => {
        const stats = productStats[producto.id] || {
          cantidadPendiente: producto.cantidad,
        };
        return stats.cantidadPendiente === 0;
      });

      setAllProductsProcessed(allProcessed);
    };

    checkAllProductsProcessed();
    // eslint-disable-next-line
  }, [order.productos, productStats]);

  // Pagination handler
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <Layouts>
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <Card title="Ingresar Orden">
          {loading ? (
            <p>Cargando orden...</p>
          ) : (
            <Space
              split={<Divider type="vertical" />}
              size={"large"}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <p>Orden #: {order.id} </p>
              <p>Factura #: {order.numero_factura} </p>
              <p>
                proveedor : {order.proveedor ? order.proveedor.nombre : null}
              </p>
              <p>
                fecha creacion :{" "}
                {order.date_created
                  ? new Date(order.date_created).toLocaleDateString("es-ES", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : ""}
              </p>
            </Space>
          )}
        </Card>
        <div>
          {loading ? (
            <p>Cargando productos...</p>
          ) : order.productos && order.productos.length > 0 ? (
            <>
              {order.productos.map((producto) => {
                const stats = productStats[producto.id] || {
                  totalIngresados: 0,
                  cantidadPendiente: producto.cantidad,
                  precioTotal: 0,
                };
                return (
                  <Card key={producto.id}>
                    <Space
                      direction="horizontal"
                      split={<Divider type="vertical" />}
                    >
                      {producto ? producto.producto_detalle?.nombre : null}
                      <p>Cantidad Pendiente: {stats.cantidadPendiente}</p>
                      <p>Ingresados: {stats.totalIngresados}</p>
                      <Space>
                        <Button
                          onClick={() => {
                            showModal(producto);
                          }}
                          disabled={stats.cantidadPendiente === 0}
                        >
                          Ingresar
                        </Button>
                        {stats.totalIngresados > 0 && (
                          <>
                            <Button
                              type="primary"
                              onClick={() => handleViewAddedProducts(producto)}
                            >
                              Ver Agregados ({stats.totalIngresados})
                            </Button>
                            <Button
                              type="primary"
                              danger
                              onClick={() => handleDeleteAddedProducts(producto)}
                            >
                              Eliminar Agregados
                            </Button>
                          </>
                        )}
                      </Space>
                    </Space>
                  </Card>
                );
              })}
              <div style={{ marginTop: 16, textAlign: "center" }}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={totalProductos}
                  showSizeChanger
                  pageSizeOptions={["10", "20", "50", "100"]}
                  onChange={handlePageChange}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} de ${total} productos`
                  }
                />
              </div>
            </>
          ) : (
            <p>No hay productos en la orden.</p>
          )}
          <p>Productos para Agregar: {orderTotals.totalProductos}</p>
          <p> Total Productos Agregados: {orderTotals.totalIngresados}</p>
          <p>Productos Faltantes: {orderTotals.totalPendientes}</p>
          <p>
            Precio Total Agregado:{" "}
            {formatPrice(orderTotals.precioTotal, signoMoneda)}
          </p>
          <div
            style={{
              marginTop: 16,
              padding: 16,
              background: "#f5f5f5",
              borderRadius: 8,
              width: "fit-content",
              marginLeft: "auto",
            }}
          >
            {signoMoneda === "₡" ? (
              <>
                <p style={{ margin: "0 0 8px", fontWeight: "bold" }}>
                  Subtotal : {formatPrice(orderTotals.precioTotal, signoMoneda)}
                </p>
                <p style={{ margin: "0 0 8px" }}>
                  Impuesto ITBMS :{" "}
                  {formatPrice(totals.groupTaxTotal, signoMoneda)}
                </p>
                {additionalTaxes.map((tax, index) => (
                  <p key={index} style={{ margin: "0 0 8px" }}>
                    {tax.name}: {formatPrice(tax.amount, signoMoneda)}
                  </p>
                ))}
              </>
            ) : (
              <>
                <p style={{ margin: "0 0 8px" }}>
                  Subtotal: {formatPrice(orderTotals.precioTotal, signoMoneda)}
                </p>
                <p style={{ margin: "0 0 8px" }}>
                  Impuesto ITBMS:{" "}
                  {formatPrice(totals.groupTaxTotal, signoMoneda)}
                </p>
                {additionalTaxes.map((tax, index) => (
                  <p key={index} style={{ margin: "0 0 8px" }}>
                    {tax.name}: {formatPrice(tax.amount, signoMoneda)}
                  </p>
                ))}
              </>
            )}
            <p
              style={{
                margin: 0,
                fontWeight: "bold",
                borderTop: "1px solid #d9d9d9",
                paddingTop: 8,
              }}
            >
              Total Final: {formatPrice(totals.grandTotal, signoMoneda)}
            </p>
          </div>
          <Button
            type="primary"
            disabled={!allProductsProcessed}
            onClick={cerrarOrden}
          >
            Cerrar Orden de Compra
          </Button>
        </div>
        <div>
          <Modal
            width={700}
            footer={[
              <Button key="ok" type="primary" onClick={handleOk}>
                Ok
              </Button>,
            ]}
            title="Ingresar producto"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <p>
              {productselect && productselect.producto_detalle
                ? productselect.producto_detalle.nombre
                : null}
            </p>
            <p>Creado Por: {order?.user_created?.first_name}</p>
            {productselect && productselect.id && <></>}

            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
          </Modal>
        </div>
        <div>
          <NoSerialModal
            open={isNoSerialModalOpen}
            onOk={handleProcessNoSerial}
            onCancel={handleCancel}
            productselect={productselect}
          />
        </div>
        {/* Modal paginado de seriales */}
        <Modal
          width={700}
          open={serialesModal.visible}
          onCancel={closeSerialesModal}
          footer={[
            <Button key="close" onClick={closeSerialesModal}>
              Cerrar
            </Button>,
          ]}
          title={
            serialesModal.producto
              ? `Seriales agregados para ${serialesModal.producto.producto_detalle?.nombre}`
              : "Seriales agregados"
          }
        >
          {serialesModal.loading ? (
            <p>Cargando seriales...</p>
          ) : (
            <>
              <p>
                <strong>Total seriales:</strong> {serialesModal.total}
              </p>
              <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                {serialesModal.seriales && serialesModal.seriales.length > 0 ? (
                  serialesModal.seriales.map((serial, index) => (
                    <div
                      key={serial.id}
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #f0f0f0",
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "white",
                      }}
                    >
                      <strong>Serial:</strong> {serial.serial} |{" "}
                      <strong>Estado:</strong> {serial.estado?.estado || "N/A"}
                    </div>
                  ))
                ) : (
                  <p>No hay seriales en esta página.</p>
                )}
              </div>
              <div style={{ marginTop: 16, textAlign: "center" }}>
                <Pagination
                  current={serialesModal.currentPage}
                  pageSize={serialesModal.pageSize}
                  total={serialesModal.total}
                  showSizeChanger
                  pageSizeOptions={["50", "100", "200"]}
                  onChange={handleSerialesPageChange}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} de ${total} seriales`
                  }
                />
              </div>
            </>
          )}
        </Modal>
      </Space>
    </Layouts>
  );
}

const NoSerialModal = ({ open, onOk, onCancel, productselect }) => {
  if (!productselect) return null;
  const quantity = productselect.cantidad;

  return (
    <Modal
      width={500}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="process" type="primary" onClick={onOk}>
          Procesar {quantity}
        </Button>,
      ]}
      title="Ingresar producto sin seriales"
      open={open}
      onOk={onOk}
      onCancel={onCancel}
    >
      <p>
        Producto:{" "}
        {productselect.producto_detalle
          ? productselect.producto_detalle.nombre
          : null}
      </p>
      <p>Cantidad: {quantity}</p>
      <p>Precio Unitario: {productselect.precio_uni_final}</p>
    </Modal>
  );
};

export default OrdeEnter;
